import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@spartacus/core';
import { ColumnConfig } from 'material-dynamic-table';
import { DeviceDetectorService } from 'ngx-device-detector';
import { StorageService } from 'src/app/service/storage/storage.service';

@Component({
  selector: 'app-employee-add-lists',
  templateUrl: './employee-add-lists.component.html',
  styleUrls: ['./employee-add-lists.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [RouterLink, MatIcon, MatTooltip, TranslatePipe],
})
export class EmployeeAddListsComponent implements OnInit {
  @Input() column: ColumnConfig;
  @Input() row: any;
  constructor(public deviceDetectorService: DeviceDetectorService, private storageService: StorageService) {}

  ngOnInit() {}

  onClickEdit() {
    this.storageService.setSessionStorageItem('status', this.row.active);
    this.storageService.setSessionStorageItem('lastname', this.row?.lastName ?? '');
    this.storageService.setSessionStorageItem('firstname', this.row.firstName);
    this.storageService.setSessionStorageItem('email', this.row.email);
    this.storageService.setSessionStorageItem('jobtitle', this.row.jobTitle);
    if (typeof this.row.defaultAddress !== 'undefined') {
      this.storageService.setSessionStorageItem('address', this.row.defaultAddress.id);
    }
    if (typeof this.row.defaultAddress !== 'undefined') {
      this.storageService.setSessionStorageItem('formattedadd', this.row.defaultAddress.formattedAddress);
    }
    this.storageService.setSessionStorageItem('useruid', this.row.uid);
    if (typeof this.row.storeFrontPermissions !== 'undefined') {
      this.storageService.setSessionStorageItem('storeFrontPermissions', this.row.storeFrontPermissions);
    }
  }
}
